const PhoneFormatter = (phone) => {
  if (String(phone).startsWith("+")) {
    return phone;
  }
  return `+${phone}`;
};

export default PhoneFormatter;
